<template>
    <div>
        <div v-if="$root.user.active">
            <div class="row setting row-last explanation">
                <div>
                    <div>
                        Pas hier de nummer instellingen aan.
                    </div>
                </div>
            </div>
            <div class="row head">
                <div class="col col-100">Huidig nummer</div>
            </div>
            <div class="row row-single setting outgoing-number" v-if="number.active == 1" v-for="(number, index) in phoneNumbers">
                <div v-if="$root.app.platform == 'android'" class="col col-100" v-bind:class="{ 'validation-error': $v.phoneNumbers.$each.$error }">
                    <input v-model="number.name" type="text" @input="$v.phoneNumbers.$touch()"/>
                    {{ number.phoneNumber }}
                </div>
                <div v-if="$root.app.platform == 'ios'" class="col col-50" v-bind:class="{ 'validation-error': $v.phoneNumbers.$each.$error }">
                    <input v-model="number.name" type="text" @input="$v.phoneNumbers.$touch()"/>
                </div>
                <div v-if="$root.app.platform == 'ios'" class="col col-50">
                    <span class="row__subtitle">{{ number.phoneNumber }}</span>
                </div>
            </div>
            
            <div class="row spacer" v-if="$root.app.platform == 'ios'">&nbsp;</div>

            <div v-if="Object.keys(this.phoneNumbers).length > 1">
                <div class="row head">
                    <div class="col col-100">Overige nummers</div>
                </div>
                <div v-if="number.active == 0" class="row setting row-list-item" v-for="(number, index) in phoneNumbers">
                    <div class="col col-100" v-if="$root.app.platform == 'android'" v-bind:class="{ 'validation-error': $v.phoneNumbers.$each.$error }">
                        <input v-model="number.name" type="text" @input="$v.phoneNumbers.$touch()"/>
                        {{number.phoneNumber}}
                    </div>
                    <div v-if="$root.app.platform == 'ios'" class="col col-50" v-bind:class="{ 'validation-error': $v.phoneNumbers.$each.$error }">
                        <input v-model="number.name" type="text" @input="$v.phoneNumbers.$touch()"/>
                    </div>
                    <div v-if="$root.app.platform == 'ios'" class="col col-50">
                        <span class="row__subtitle">{{ number.phoneNumber }}</span>
                    </div>
                </div>
            </div>

<!--            <div class="row setting">
                <div class="col col-100">
                    <span class="subtitle">Uitgaand nummer</span><br/>
                    <div class="select-wrap">
                        <svg viewBox="0 0 24 24" class="select-arrow"><path d="M7 10l5 5 5-5z"></path></svg>
                        <select @change="changedValue" name="phone">
                            <option v-for="(numbers, key) in phoneNumbers" :value="key" :value.sync="key" :selected="numbers.active == 1">
                                {{ numbers.phoneNumber }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>-->
        </div>
        <div v-else>
            <div class="row setting notice">
                <div class="col col-100">
                    <b>Inactief account</b><br> 
                    Uw abonnement is verlopen. Wilt u een nieuw abonnement? Neem dan contact op met onze helpdesk via 'Ondersteuning'.
                </div>
            </div>
        </div>
        <div class="row spacer" v-if="$root.app.platform == 'ios'">&nbsp;</div>
             
        <div class="row row-button">
            <div class="col col-100">
                <button class="button" @click="editInfo">Gegevens opslaan</button>
            </div>
        </div>
    </div>
</template>

<script>

    import {helpers, required, minLength, maxLength, alphaNum } from 'vuelidate/lib/validators'
    const alpha = value => { return /^[a-zÀ-ú0-9_ ]*$/i.test(value) }

    export default {
    name: 'Numbers',
        data () {
            
            return {
                numberSwitchType: 'global',
                phoneNumbers: []
            }
        },
        validations: {
            phoneNumbers: {
                $each: {
                    name: {
                        required,
                        alpha,
                        minLength: minLength(1),
                        maxLength: maxLength(15),
                    }
                }
            }
        },

        mounted(){
            
            
        },
        
        created(){
            
            this.getPhoneNumbers();
        },
        
        methods:{
            
            getPhoneNumbers(){
                
                this.$api.get('/numbers')
                .then(response => {
                    this.numberSwitchType = response.data.numberSwitchType;
                    this.phoneNumbers = response.data.phoneNumbers;
                })
                .catch(e => {
                
                })  
            },
            
            lastItem: function(index) {
                
            },

            editInfo()
            {
                if(this.$v.$invalid) {
                this.$root.ui.showDialog(
                    'Fout',
                    'De nummer naam is niet correct, let op dat je geen vreemde tekens en / of leestekens gebruikt en dat hij niet langer is dan 15 karakters<br/>',
                    true
                );
                return; 
            }

                var _this = this;
                var root = this.$root;
                root.loading = true;
                root.app.state = 'save';


                this.$api.post('/numbers/edit', this.phoneNumbers)
                .then(response => {
                    root.loading = false;
                    root.app.state = 'get';
                    
                    _this.$root.ui.showDialog(
                        'Voltooid',
                        'Nummer is opgeslagen.',
                        true
                    );
                })
                .catch(error => {
                    root.loading = false;
                    root.app.state = 'get';
                    
                    _this.$root.ui.showDialog(
                        'Fout',
                        'De gegevens konden niet worden opgeslagen door een fout:<br/>'+e.response.data.message,
                        true
                    );
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Numbers.vue